const srcURL =
  process.env.REACT_APP_API_ENDPOINT || "https://api.dev.awaydh.com/";
export const ServerlessConfigure: {
  ApiEndpoint: string;
  MaterialsEndpoint: string;
  CategoriesEndpoint: string;
  ColoursEndpoint: string;
  FinishesEndpoint: string;
  LocationsEndpoint: string;
  ManufacturersEndpoint: string;
  RangesEndpoint: string;
  SwapperGroupsEndpoint: string;
  SwapperListsEndpoint: string;
} = {
  // TODO: remove when every request endpoint is updated
  ApiEndpoint:
    process.env.REACT_APP_API_ENDPOINT || "https://api.dev.awaydh.com/",
  MaterialsEndpoint: srcURL + "materials/materials",
  CategoriesEndpoint: srcURL + "materials/categories",
  ColoursEndpoint: srcURL + "materials/colours",
  FinishesEndpoint: srcURL + "materials/finishes",
  LocationsEndpoint: srcURL + "materials/locations",
  ManufacturersEndpoint: srcURL + "materials/manufacturers",
  RangesEndpoint: srcURL + "materials/ranges",
  SwapperGroupsEndpoint: srcURL + "materials/swapperGroups",
  SwapperListsEndpoint: srcURL + "materials/swapperLists",
};
